//import React from 'react';

//import ReactDOM from 'react-dom';



class Ajax extends Object
{

    static createAjaxRequestObject() {
    var xmlhttp;

    if (window.XMLHttpRequest) { // code for IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp = new XMLHttpRequest();
        xmlhttp.withCredentials = true;
    } else { // code for IE6, IE5
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    // Create the object
    return xmlhttp;
    }

    

    

    static performRequest(ajaxURL, method, parameters, onComplete, parametersIsFile)
    {
        var http3 = Ajax.createAjaxRequestObject();

        http3.onreadystatechange = function() {
            if(http3.readyState == 4) {
                if(http3.status == 200) {
                    if(onComplete) {
                        onComplete(http3.responseText);
                    }
                }
                else if(onComplete) {
                    onComplete(null);
                }
            }
        };

        // Create parameter string
        var params;
        

        // Make request
        http3.open(method, ajaxURL, true);
        if(parametersIsFile)
        {
            params = new FormData();
            params.append('file', parameters);
            //http3.setRequestHeader("content-type", "multipart/form-data");
        }
        else if(parameters != null)
        {
            params = JSON.stringify(parameters);
            //http3.setRequestHeader("content-type", "multipart/form-data");
            //http3.setRequestHeader("Access-Control-Allow-Credentials", "true");
        }
        /*
        console.log("url:");
        console.log(ajaxURL);
        console.log("params:");
        console.log(params);
        console.log("Method:");
        console.log(method);
*/
        http3.send(params);
}
}
export default Ajax;



// WEBPACK FOOTER //
// ./js/AJAX.jsx